const styles = (theme) => ({
  label: {
    marginTop: theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 1,
    fontWeight: 600,
    fontSize: '1.0625rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  textFieldLabel: {
    marginBottom: -theme.spacing.unit,
  },
  helpText: {
    marginTop: theme.spacing.unit,
  },
  contactHelpText: {
    marginTop: theme.spacing.unit * 2,
  },
  timeFieldIntroContainer: {
    '& h4': {
      marginTop: theme.spacing.unit * 1.5,
      marginBottom: 0,
      fontWeight: 600,
      fontSize: '1.0625rem',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.125rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '1.25rem',
      },
    },
    '& p': {
      marginTop: theme.spacing.unit,
      marginBottom: 0,
    },
  },
  timeFieldContainer: {
    marginTop: theme.spacing.unit * 2,
    maxWidth: 280,

    '& label > span': {
      padding: theme.spacing.unit,
    },
  },
  availabilityColumn: {
    textAlign: 'center',
    alignSelf: 'center',
  },
  selectDisabled: {
    // Same opacity as used by other 'disabled' components in Material UI.
    opacity: 0.42,
  },
  divider: {
    margin: `${theme.spacing.unit * 3}px 0`,
  },
  buttonSubmit: {
    float: 'right',
  },
  dialogContent: {
    '& h4:first-child, & p:first-child, ': {
      margin: 0,
    },
    '& h4': {
      fontSize: '1.250rem',
    },
    '& h4, & p, & ul, & ol': {
      marginTop: theme.spacing.unit,
      marginBottom: 0,
    },
  },
});

export default styles;
